import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-integration-kelseys-menu-form',
  templateUrl: './integration-kelseys-menu-form.component.html',
  styleUrls: ['./integration-kelseys-menu-form.component.scss']
})
export class IntegrationKelseysMenuFormComponent {
  @Input() formGroup!: FormGroup;
}
